function Chat({ username, chatRoomURL }) {
  return (
    <div className="bg-green-300 w-full h-full relative">
      <iframe
        title="chat"
        className="absolute inset-0 w-full h-full"
        src={chatRoomURL + "?username=" + username}
      ></iframe>
    </div>
  );
}

export default Chat;
